import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import { initialFormDataUser, initialErrors, fieldValidation, createUserData  } from '../../common/helper/form-constants.js';
import ConfigService from "../../../services/config-service.js";
import UserService from '../../../services/user-service.js';
import { FormField, SelectField } from './../../common/helper/formFields';


const EditUser = () => { 
    const [merchant, setMerchant] = useState({});
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('per_details');
    const [formData, setFormData] = useState({ });
    const [errors, setErrors] = useState({ ...initialErrors });
    const [formDataPersonal, setFormDataPersonal] = useState({ });
    const [statesData,setStatesData] = useState([]);
    const [city,setCity] = useState([]);
    const [roles,setRoles] = useState([]);
    const [superVisor,setSuperVisor] = useState([]);
    const gender = [{ label : 'Male', value : 'M'},{label : 'Female',value : 'F'}]

    const { id } = useParams();
    const navigate = useNavigate();
 
    const fetchData = async () => {
        try {
          setLoading(true);
          const [statesResponse, roleResponse, supervisorResponse] = await Promise.all([
            ConfigService.getStates(),
             UserService.getRoles(),
            UserService.getSuperviors(),

          ]);
          const states =  statesResponse.data.data.map(state => ({ value: state.id, label: state.state }));
            const roles = roleResponse.data.data.map(record => ({ value: record.code, label: record.value }));
            const supervisor =  supervisorResponse.data.data.map(record => ({ value: record.key, label: record.value }));
     
         setStatesData(states)
         setRoles(roles)
         setSuperVisor(supervisor)
          getUser();
          setLoading(false);
        } catch (error) {
          setLoading(false);

        }
      };

      const getCities = (stateID, data=null) => {
        setLoading(true);
        ConfigService.getCities(stateID)
          .then(response => {
            const cities =  response.data.data.map(city => ({ value: city.id, label: city.city }));
            setCity(cities)
            setAddressInfo(data);
            setLoading(false);
          })
          .catch(error => {

            setLoading(false);

          });
      }

    const getUser = () => {
        setLoading(true);
        UserService.getUserDetails(id)
              .then(response => {
                const data =response.data.data
                setMerchant(data)
                setPersonalInfo(data);
                getCities(data.address.state_id, data)
              //  getUsers(data.user_id, data)
                setLoading(false);
              })
              .catch(error => {
                console.log(error);
                setLoading(false);
                try {
                    const errorMessage = error.response.data
                    toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
                } catch (error) {
                    console.log(error)
                    toast.error(MESSAGES.SERVER_ERROR)
                }
                
              });
      }
    
      const updateMerchantInfo = (id,data) => {
        setLoading(true);
        UserService.updateUser(id,data)
          .then(response => {
            setLoading(false);
            navigate('/users')
            toast.success(MESSAGES.USR_UPDATED)
          })
          .catch(error => {
            try{
                const errorMessage = error.response.data
                toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e) {
                toast.error( MESSAGES.SERVER_ERROR)
            }
            setLoading(false);
          });
      }
      const back = () => {
        navigate(-1); 
      }
      const setPersonalInfo = (merchant) => {
        const inputDate = merchant.date_of_birth; 
        const parts = inputDate.split('-');
        const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
        const personalInfo = {
            fullName: merchant.full_name,
            email: merchant.email_address,
            phoneNumber: merchant.mobile_number,
            gender_id: merchant.gender_id,
            role_code: merchant.role.role_code,
            supervisor_id: merchant.supervisor_id,
            date_of_birth: formattedDateOfBirth
        }
        setFormData(personalInfo);
      }
      const setAddressInfo = (merchant) => {
        const addressInfo = {
            addressLine1: merchant.address.address1,
            addressLine2: merchant.address.address2,
            city: merchant.address.city_id,
            state: merchant.address.state_id,
            postalCode: merchant.address.zip
          
        }
        setFormDataPersonal(addressInfo);
      }

 
     

      const updatePersonal = (e) => {
        e.preventDefault();
        let hasErrors = false;
        let requiredFields =['email', 'fullName', 'phoneNumber', 'role_code','date_of_birth', 'supervisor_id', 'gender_id'];
        requiredFields.forEach(fieldName => {
          const error = validateField(fieldName, formData[fieldName]);
          if (error) {
            hasErrors = true;
          }
        });
      if(!hasErrors) {
        const inputDate = formData.date_of_birth; 
          const parts = inputDate.split('-');
          const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
            const dataToupdate = {
              profile_detail:{
                full_name: formData.fullName,
                email_address: formData.email,
                mobile_number: formData.phoneNumber,
                date_of_birth: formattedDateOfBirth,
                gender_id: formData.gender_id,
                role_code: formData.role_code,
                supervisor_id: formData.supervisor_id,
                }
            }
            updateMerchantInfo(id,dataToupdate)
      }
          
  
      }
      const updateAddress = (e) => {
        e.preventDefault();
        let hasErrors = false;
        let requiredFields =['addressLine1', 'city', 'state', 'postalCode'];
        requiredFields.forEach(fieldName => {
          const error = validateField(fieldName, formDataPersonal[fieldName]);
          if (error) {
            hasErrors = true;
          }
        });
        if(!hasErrors){

            const dataToupdate = {
                address_detail:{
                    address1: formDataPersonal.addressLine1,
                    address2: formDataPersonal.addressLine2,
                    city_id:formDataPersonal.city,
                    state_id: formDataPersonal.state,
                    zip: formDataPersonal.postalCode,
                }
            }
            updateMerchantInfo(id,dataToupdate)
        }
      }
      
      const validateField = (fieldName, value) => {
        const errorMessage = fieldValidation(fieldName, value);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
        return errorMessage;
      };
     
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        validateField(name, value);
      }
      const handleChangeAddress = (e) => {
        const { name, value } = e.target;
        setFormDataPersonal((prevData) => ({ ...prevData, [name]: value }));
        validateField(name, value);
        if (name === 'state') {
          getCities(value);
        }
      }
     
      
      const setTab = (tab) => {
        setActiveTab(tab);
      };


    useEffect(() => {
        fetchData();
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
function getCurrentDate() {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();

  if (month < 10) {
      month = '0' + month;
  }
  if (day < 10) {
      day = '0' + day;
  }

  return `${year}-${month}-${day}`;
}
return(
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Edit User</h4>
    <div className="container-fluid ghty" style={{backgroundColor: 'white'}}>
    
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn" onClick={() => setTab('per_details')} >
            <a className={`nav-link ${activeTab === 'per_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_per_details" style={{cursor:'pointer'}}>Personal Information</a>
          </li>
          <li className="nav-item tbbtrn" onClick={() => setTab('address_details')} >
            <a className={`nav-link ${activeTab === 'address_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_address_details" style={{cursor:'pointer'}}>Address</a>
          </li>
        
        </ul>
        <div  style={{marginTop: '16px'}}>
            <form onSubmit={updatePersonal} className="tab-content">
          <div  className={`tab-pane ${activeTab === 'per_details' ? 'active' : 'fade'}`} id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                       <FormField
                           type="text"
                           isRequierd = {true}
                           id="f_name"
                           name="fullName"
                           label="FULL NAME"
                           placeholder = "Enter Full Name"
                           value={formData.fullName}
                           onChange={handleChange}
                           error={errors.fullName}
                           maxlength = {20}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="phone"
                           name="phoneNumber"
                           label="PHONE NUMBER"
                           placeholder = "Enter Phone Number"
                           value={formData.phoneNumber}
                           onChange={handleChange}
                           error={errors.phoneNumber}
                           maxlength = {10}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                    <SelectField 
                                id="gender_id"
                                isRequierd = {true}
                                name="gender_id"
                                label="GENDER"
                                selectedField = "Select Gender"
                                value={formData.gender_id}
                                onChange={handleChange}
                                error={errors.gender_id}
                                options={gender}
                                />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                      <FormField
                             type="date"
                             isRequierd = {true}
                             id="date_of_birth"
                             name="date_of_birth"
                             label="DATE OF BIRTH"
                             placeholder = "Enter DOB"
                             value={formData.date_of_birth}
                             onChange={handleChange}
                             error={errors.date_of_birth}
                             max={getCurrentDate()}
                          />
                      </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                       <FormField
                           type="email"
                           isRequierd = {true}
                           id="email"
                           name="email"
                           label="E-mail"
                           placeholder = "Enter Email"
                           value={formData.email}
                           onChange={handleChange}
                           error={errors.email}
                           disabled={true}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                                id="role_code"
                                isRequierd = {true}
                                name="role_code"
                                label="ROLE"
                                selectedField = "Select Role"
                                value={formData.role_code}
                                onChange={handleChange}
                                error={errors.role_code}
                                options={roles}
                                />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                                id="supervisor_id"
                                isRequierd = {true}
                                name="supervisor_id"
                                label="Supervisor"
                                selectedField = "Select Supervisor"
                                value={formData.supervisor_id}
                                onChange={handleChange}
                                error={errors.supervisor_id}
                                options={superVisor}
                                />
                        </div>
                  </div>
                </div>
                <br />
                <div align="left">
                <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          </form >
          <form className="tab-content" onSubmit={updateAddress}>
          <div className={`tab-pane ${activeTab === 'address_details' ? 'active' : 'fade'}`} id="address_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="f_name">ADDRESS LINE 1</label>
                      <input type="text" className="form-control" id="address_1" placeholder="Enter Address" name="address_1" />
                      <span id="error_address_1" className="text-danger" /> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="addressLine1"
                           name="addressLine1"
                           label="ADDRESS LINE 1"
                           placeholder = "Enter Address"
                           value={formDataPersonal.addressLine1}
                           onChange={handleChangeAddress}
                           error={errors.addressLine1}
                           maxlength = {50}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="state"
                       isRequierd = {true}
                       name="state"
                       label="STATE"
                       selectedField = "Select State"
                       value={formDataPersonal.state}
                       onChange={handleChangeAddress}
                       error={errors.state}
                       options={statesData}
                    />
                    
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="postalCode"
                           name="postalCode"
                           label="POSTAL CODE"
                           placeholder = "Enter Postal Code"
                           value={formDataPersonal.postalCode}
                           onChange={handleChangeAddress}
                           error={errors.postalCode}
                           maxlength = {6}
                        />
                      
                    </div>
                   
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="addressLine2"
                           name="addressLine2"
                           label="ADDRESS LINE 2"
                           placeholder = "Enter Address"
                           value={formDataPersonal.addressLine2}
                           onChange={handleChangeAddress}
                           error={errors.addressLine2}
                           maxlength = {50}
                        />
                      
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                       <SelectField 
                       id="city"
                       isRequierd = {true}
                       name="city"
                       label="CITY"
                       selectedField = "Select City"
                       value={formDataPersonal.city}
                       onChange={handleChangeAddress}
                       error={errors.city}
                       options={city}
                    />
                      
                    </div>
                 
                  </div>
                </div>
                <br />
                <div align="left">
                
                <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          </form>
    
        </div>

    </div>
  </div>
  </div>
)


}


function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
  export default withAuth(connect(mapStateToProps)(EditUser));